module.exports = __webpack_public_path__ + "static/img/member_list_3.5827a2af.png";